import { Button, DrawingCanvasMode, DrawingCanvasShapeType } from '@civilgrid/ui/components';

export type DrawingTool = {
  mode: DrawingCanvasMode;
  shapeType?: DrawingCanvasShapeType.LINE | DrawingCanvasShapeType.POLYGON;
};

type DrawToolButtonsProps = {
  tool: DrawingTool;
  onToolChange: (tool: DrawingTool) => void;
};

const DRAW_TOOLS = [
  { shapeType: DrawingCanvasShapeType.LINE, label: 'Draw line', testId: 'civildraw-draw-line-button' },
  { shapeType: DrawingCanvasShapeType.POLYGON, label: 'Draw polygon', testId: 'civildraw-draw-polygon-button' },
] as const;

/** Buttons that switch the canvas to drawing a line or a polygon. */
// TODO(CG-1555): replace these with the drawing tool picker
export default function DrawToolButtons({ tool, onToolChange }: DrawToolButtonsProps) {
  return (
    <div className="flex gap-2">
      {DRAW_TOOLS.map(({ shapeType, label, testId }) => {
        const isDrawing = tool.mode === DrawingCanvasMode.DRAW && tool.shapeType === shapeType;
        return (
          <Button
            key={shapeType}
            type="button"
            variant={isDrawing ? 'selected' : 'secondary'}
            aria-pressed={isDrawing}
            data-testid={testId}
            onClick={() =>
              onToolChange(isDrawing ? { mode: DrawingCanvasMode.EDIT } : { mode: DrawingCanvasMode.DRAW, shapeType })
            }
          >
            {label}
          </Button>
        );
      })}
    </div>
  );
}
